import Cookies from 'js-cookie'
import { SESSION_ID_COOKIE_NAME } from '../../login/get-session-id'

export const logNewRelicEvent = (
  eventName: string,
  data: Record<string, string | number | boolean>,
) => {
  if (typeof window === 'undefined') {
    return
  }

  const updatedData = {
    ...data,
    client_timestamp: Date.now(),
    user_id: Cookies.get('user_id') ?? '',
    session_id: Cookies.get(SESSION_ID_COOKIE_NAME) ?? '',
  }

  if (process.env.NODE_ENV === 'development') {
    return
  }
  if (window.newrelic) {
    window.newrelic.addPageAction(eventName, updatedData)
  } else {
    console.info('Newrelic not found')
  }
}
